import { fetchUserInfo, updateUserInfo } from "actions/userActions"
import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { getUserInfo } from "reducers/userInfo"

const UserContext = React.createContext(null)

export const useCurrentUser = () => React.useContext(UserContext)

export function UserContextProvider({ children }): JSX.Element {
  const dispatch = useDispatch()
  const userInfo = useSelector(getUserInfo)

  function refreshUserInfo() {
    return dispatch(fetchUserInfo())
  }
  return (
    <UserContext.Provider
      value={{
        refreshUserInfo,
        updateUserInfo: (...args) => dispatch(updateUserInfo(...args)),
        ...userInfo
      }}
    >
      {children}
    </UserContext.Provider>
  )
}
